// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3w3bf","focado":"OptionSelect_focado__mP_S_"};